import axios from 'axios'
//import APP_CONSTANT from '../../config/config'
//import qs from 'qs';
const allAxiosCommonTA = async function (props = {}) {
    let token = localStorage.getItem('isloggedIn')
    let userId = localStorage.getItem('userId')
    let customerNo = localStorage.getItem('customerNumber')
    let congData =
    {
        customerNo: customerNo,
        customerNumber: customerNo,
        customer_no: customerNo,
        userId: userId,
        user_id: userId,
        ...props.Items
    }
    let response = await axios.request({
        //baseURL: props.baseURL ? props.baseURL : APP_CONSTANT.BASE_COMMON,
        baseURL: process.env.REACT_APP_TA_API_URL,
        url: props.method == 'get' ? `${props.url}${props.getValues ? `?${props.getValues}` : '?'}customerNo=${customerNo}&customerNumber=${customerNo}&customer_no=${customerNo}&user_id=${userId}&userId=${userId}${props.hStatus ? `&common_delivery=1&customer_no=${customerNo}&user_id=${userId}` : ''}` : props.url,
        method: props.method,
        data: props.method != 'get' ? congData : '',
        headers: {
            'Content-Type': ` ${props.contentType ? props.contentType : 'application/json'};charset=utf-8`,
            'Authorization': `${token}`
        },
    })
    let resp = new Promise((resolve, reject) => {
        if (response.status === 200 || response.status === 201) {
            resolve(response)
        } else {
            reject(response)
        }
    })
    return resp;
}
export default allAxiosCommonTA